import { queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { DailyVisitors, Website } from "@/api/types"

export function dailyVisitorsOptions(website: Website, days: number) {
	return queryOptions({
		queryKey: ["analytics", website, "daily", days],
		queryFn: (): Promise<DailyVisitors[]> =>
			GET("/api/v1/analytics/{website}/daily", {
				params: { path: { website }, query: { days } },
			}),
	})
}

export function useDailyVisitors(website: Website, days: number) {
	return useQuery(dailyVisitorsOptions(website, days))
}
